import { Err, isErr, Ok, Result } from "@pacote/result"
import useSWRMutation from "swr/mutation"

import {
  ApiFailure,
  BaseApiErrorResponse,
  UnhandledApiError,
} from "./api-config"
import { withAuthClientFetcher } from "./base-fetchers"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/
type VerifyPhoneNumberPayload = {
  phone: string
}

/* -------------------------------------------------------------------------------------------------
 * config
 * -----------------------------------------------------------------------------------------------*/
const verifyPhoneNumberServiceEndpoint =
  "/profilo-ms/ms/profile/validate/loggedPhone"
/* -------------------------------------------------------------------------------------------------
 * fetcher
 * -----------------------------------------------------------------------------------------------*/
const verifyPhoneNumberFetcher = async (
  key: string,
  { arg: { phone } }: { arg: VerifyPhoneNumberPayload },
): Promise<Result<null, { type: string; errorMessage: string }>> => {
  const resultResponse = await withAuthClientFetcher<
    void,
    BaseApiErrorResponse
  >({
    url: key,
    params: {
      phone,
    },
  })

  if (!isErr(resultResponse)) return Ok(null)

  const response = resultResponse.value

  if (response.status !== 422)
    throw new UnhandledApiError({
      status: ApiFailure.UNPROCESSABLE_ERROR,
      message: `A non 422 status was returned from ${key} service.`,
      originalStatus: response.status,
      data: response.data,
    })

  const errorInfos = response.data.error?.errorInfos

  if (!errorInfos || !errorInfos.phone?.length)
    throw new UnhandledApiError({
      status: ApiFailure.UNPROCESSABLE_ERROR,
      message: `Invalid errorInfos response`,
      originalStatus: response.status,
      data: errorInfos,
    })

  return Err({
    type: "INVALID_PHONE",
    errorMessage: errorInfos.phone[0] ?? "",
  })
}

/* -------------------------------------------------------------------------------------------------
 * hooks
 * -----------------------------------------------------------------------------------------------*/

const useVerifyPhoneNumberMutation = () =>
  useSWRMutation(verifyPhoneNumberServiceEndpoint, verifyPhoneNumberFetcher)

export { useVerifyPhoneNumberMutation }
